import { find } from 'lodash';

import { PriceBookEntryVm, ProductPricingType } from '@/types';

export const calcWarrantyTotal = (warranty?: PriceBookEntryVm | null, roofSize?: number | null) => {
  if (!warranty?.unitPrice) {
    return 0;
  }

  if (
    warranty?.pricingType === ProductPricingType['Roof Sized'] &&
    warranty?.pricePerSquare !== null &&
    roofSize
  ) {
    return warranty?.pricePerSquare * roofSize;
  }

  return warranty.unitPrice;
};

export const calcWarrantiesTotal = (warranties: PriceBookEntryVm[], roofSize?: number | null) => {
  return warranties.reduce((sum, warranty) => sum + calcWarrantyTotal(warranty, roofSize), 0);
};

export const getWarrantyName = (warranty: PriceBookEntryVm) =>
  warranty.product.portalName ?? warranty.product.name;

export const getWarrantyByName = (name: string | null, warranties: PriceBookEntryVm[]) =>
  find(warranties, ['product.portalName', name]);
